export * from './confirmation-config';
